<select [ngClass]="className" (change)="selectState($event.target.value)">
    <option *ngFor="let state of states" [value]="state.state" [selected]="state.state == initialState">
        {{ state.state_name }}
    </option>
</select>
<p class="help is-danger" *ngIf="showError && className === 'purchase-state-select'"
    [ngStyle]="{'justify-content': 'center'}">Please choose state where the property is located in.</p>